import Button from 'components/form/Button';
import InputOTP from 'components/form/InputOTP';
import { Card } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';

const VerifyOtpModel = ({
  title,
  showApproveDialog,
  onHide,
  onVerify,
  sendOtpRequest,
  otpVerification,
}) => {
  const [resetOTP, setResetOTP] = useState(true);
  const [otp, setOTP] = useState('');
  const [counter, setCounter] = useState(600);
  const [isOTPSent, setIsOTPSent] = useState(true);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    if (counter === 0) {
      setIsOTPSent(false);
    }
    setResetOTP(true);
  }, [counter]);

  const handleOtp = (newOtp) => {
    if (newOtp) {
      setOTP(newOtp);
    }
  };

  const handelVerifyOTP = async () => {
    if (otp.length === 6 && onVerify) {
      await onVerify(otp);
    }
  };

  return (
    <Modal
      //   size="md"
      // onHide={onHide}
      show={showApproveDialog}
      dialogClassName="w-584"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div id="forgot-password-container ">
        <Modal.Header className="border-0">{title}</Modal.Header>
        <Card className="card-padding ps-5 pe-5 pb-5 text-center border-top-0">
          <div className="position-relative mb-3">
            <div className="text-20-500 color-title-navy">Enter OTP</div>
          </div>

          <Formik
            initialValues={{}}
            onSubmit={() => {
              handelVerifyOTP();
            }}
          >
            {(props) => {
              const { handleSubmit } = props;
              return (
                <form
                  onSubmit={handleSubmit}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleSubmit();
                    }
                  }}
                >
                  <div className="center-flex flex-column">
                    <InputOTP
                      blockSize={6}
                      resetOTP={resetOTP}
                      onSubmit={handleOtp}
                      setResetOTP={setResetOTP}
                      // isDisableTyping={loadButton}
                    />
                  </div>
                  <div className="mt-5 mb-4">
                    {isOTPSent && (
                      <div className="text-center text-14-400">OTP sent!</div>
                    )}
                    {counter === 0 ? (
                      <div className="d-flex justify-content-center">
                        If you didn't receive a code!
                        <span
                          className="text-decoration-underline ps-1"
                          role="button"
                          style={{ color: '#264cbf' }}
                          onClick={() => {
                            sendOtpRequest();
                            setIsOTPSent(true);
                          }}
                        >
                          Resend
                        </span>
                      </div>
                    ) : (
                      <div className="text-center text-16-400 mt-2">
                        You can resend the OTP in
                        <span className="color-new-car text-16-500">
                          {` ${String(Math.floor(counter / 60)).padStart(
                            2,
                            '0'
                          )}:${String(counter % 60).padStart(2, '0')}`}
                        </span>
                      </div>
                    )}
                  </div>

                  <div className="ps-5 pe-5 d-flex justify-content-center align-items-center gap-3">
                    <Button
                      text="Verify"
                      btnStyle="primary-dark"
                      className="h-37 text-14-500 cps-30 cpe-30"
                      onClick={handelVerifyOTP}
                      disabled={
                        !otp || (otp && otp.length !== 6) || otpVerification
                      }
                      btnLoading={otpVerification}
                    />
                    <Button
                      text="Cancel"
                      btnStyle="light-outline"
                      className="h-37 text-14-500 cps-20 cpe-20"
                      onClick={onHide}
                      disabled={otpVerification}
                    />
                  </div>
                </form>
              );
            }}
          </Formik>
        </Card>
      </div>
    </Modal>
  );
};

export default VerifyOtpModel;
